import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ROUTES } from '@/constants/routes';

/** Shown when an authenticated user's role doesn't permit the route — never a bare 404 (§13.2). */
export function ForbiddenPage() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ minHeight: '100vh', textAlign: 'center', p: 3 }}
    >
      <Typography variant="h1" fontWeight={700}>
        403
      </Typography>
      <Typography variant="h6">You don't have access to this page.</Typography>
      <Typography variant="body2" color="text.secondary">
        If you think this is a mistake, contact your Willnq administrator.
      </Typography>
      <Button component={RouterLink} to={ROUTES.root} variant="contained">
        Back to home
      </Button>
    </Stack>
  );
}
